<template>
    <div>

        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" offset="17">
                    <el-button type="success" size="mini" @click="handleAdd({})">新增菜单</el-button>
                </el-col>
                <el-col :span="3" >
                    <el-tooltip class="item" effect="dark" content="点这里更新公众号菜单" placement="top-end">
                        <el-button type="success" size="mini" @click="push">更新公众号菜单</el-button>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>
        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="menuId" label="编号" width="100"></el-table-column>
            <el-table-column prop="menuName" label="名称" width="100"></el-table-column>
            <el-table-column prop="menuKey" label="key" width="100"></el-table-column>
            <el-table-column prop="menuUrl" label="连接" width="150"></el-table-column>
            <el-table-column prop="menuType" label="菜单类型" width="100"></el-table-column>
            <el-table-column prop="menuLevel" label="菜单级别" width="100"></el-table-column>
            <el-table-column prop="platformIdName" label="平台" width="100"></el-table-column>
            <el-table-column prop="sort" label="排序" width="100"></el-table-column>
            <el-table-column prop="fatherMenuName" label="父菜单" width="100">
                <template slot-scope="scope">
                    <span>{{(scope.row.fatherMenuName == '0' || scope.row.fatherMenuName == '') ? '无' : scope.row.fatherMenuName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="warning" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="success" v-show="scope.row.menuLevel==1" size="mini"
                                   @click="handleAdd(scope.row)">添加子菜单

                        </el-button>
                        <el-button type="danger" size="mini"
                                   @click="handDelete(scope.row)">删除

                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="menuId" :hidden="true">
                    <el-input v-model=form.menuId></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId" placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="菜单名称" :required="true">
                    <el-input v-model=form.menuName clearable placeholder="菜单名称"></el-input>
                </el-form-item>
                <el-form-item label="菜单Key" >
                    <el-input v-model=form.menuKey disabled="true"  clearable placeholder="菜单Key 不允许重复 建议使用有意义的英文单词或者拼音 "></el-input>
                </el-form-item>
                <el-form-item label="菜单类型" :required="true">
                    <el-select v-model="form.menuType" placeholder="菜单类型" @change="menuTypeChange">
                        <el-option v-for="item in menuTypeList"
                                   :key="item.key"
                                   :label="item.value"
                                   :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="跳转连接" :required="true" v-show="!miniType">
                    <el-input v-model=form.menuUrl clearable placeholder="跳转连接"></el-input>
                </el-form-item>
                <el-form-item label="appId" v-show="false">
                    <el-input v-model=form.appId clearable placeholder="跳转小程序时必填:wxccfc57d73bc81766,否则为空"></el-input>
                </el-form-item>
                <el-form-item label="页面路径" v-show="miniType" :required="true">
                    <el-input v-model=form.pagePath placeholder="跳转小程序时必填"></el-input>
                </el-form-item>
                <el-form-item label="排序" :required="true">
                    <el-input-number v-model=form.sort placeholder="排序" :min="0" :max="29"></el-input-number>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-tooltip class="item" effect="dark" content="确定保存后，需要更新公众号菜单" placement="top-end">
                        <el-button type="primary" @click="save()">确 定</el-button>
                    </el-tooltip>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getWeiXinMenuList, saveMenu, pushMenu, pullMenu,getMenuKey, getPlatformList2, deleteMenu} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                keywordData: [],
                loading: true,
                dialogFormVisible: false,
                miniType: false,
                menuTypeList: [
                    {key: 'click', value: '点击推事件'},
                    {key: 'view', value: '跳转URL'},
                    {key: 'scancode_push', value: '扫码推事件'},
                    {key: 'scancode_waitmsg', value: '扫码推事件且弹出“消息接收中”'},
                    {key: 'pic_sysphoto', value: '弹出系统拍照'},
                    {key: 'pic_photo_or_album', value: '弹出拍照或者相册'},
                    {key: 'pic_weixin', value: '弹出微信相册'},
                    {key: 'location_select', value: '弹出地理位置'},
                    {key: 'media_id', value: '下发消息（除文本消息）'},
                    {key: 'miniprogram', value: '打开小程序'},
                    {key: 'view_limited', value: '跳转图文消息URL'}],
                form: {
                    menuId: '',
                    menuName: '',
                    menuKey: '',
                    menuUrl: '',
                    menuType: '',
                    platformId: '',
                    appId: '',
                    sort: 0,
                    pagePath: ''
                },
                formInline: {
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                platformDisabled: false
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            getPlatformList2().then((res) => {
                this.platformData = res.data;
            });
            this.getList();
        },
        methods: {
            //定义查询方法
            getList(){
                this.loading = true;
                getWeiXinMenuList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            menuTypeChange(type){
                this.miniType = type == 'miniprogram';
                this.form.appId = this.miniType ? 'wxccfc57d73bc81766' : ''
            },
            handleAdd(row){
                this.dialogFormVisible = true;
                this.form = {
                    menuId: '',
                    menuName: '',
                    menuKey: '',
                    menuUrl: '',
                    menuType: '',
                    platformId: row.platformId || '',
                    fId: row.menuId || '0',
                    appId: '',
                    sort: 0,
                    pagePath: ''
                }
                this.platformDisabled = this.form.platformId !== '';
                getMenuKey().then((res) => {
                    console.log(res);
                    this.form.menuKey=res.data.value.key
                })
            },
            handleEdit(data){
                if (confirm("确认修改吗？")) {
                    this.dialogFormVisible = true;
                    this.platformDisabled = true;
                    this.form = {
                        menuId: data.menuId,
                        menuName: data.menuName,
                        menuKey: data.menuKey,
                        menuUrl: data.menuUrl,
                        fId: data.fId,
                        sort: data.sort,
                        menuType: data.menuType,
                        platformId: data.platformId,
                        appId: data.appId,
                        pagePath: data.pagePath
                    };
                    this.menuTypeChange(data.menuType);
                }
            },
            handDelete(row){
                if (confirm("删除不可撤销，确认删除吗？")) {
                    this.loading = true;
                    deleteMenu({menuId: row.menuId}).then((res) => {
                        //console.log(res);
                        this.loading = false;
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                            this.dialogFormVisible = false;
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            save(){
                console.log(this.form);
                if (this.form.menuName == "") {
                    this.$message({
                        message: "请输入菜单名称",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.menuKey == "") {
                    this.$message({
                        message: "请输入菜单key",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.platformId == "") {
                    this.$message({
                        message: "请选择公众号平台",
                        type: 'error'
                    });
                    return;
                }
                if (this.miniType) {
                    this.form.menuUrl = 'http://mp.weixin.qq.com'
                    this.form.appId = 'wxccfc57d73bc81766';
                } else {
                    this.form.appId = ''
                }
                this.loading = true;
                saveMenu(this.form).then((res) => {
                    //console.log(res);
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            pull(){
                this.loading = true;
                pullMenu().then((res) => {
                    //console.log(res);
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            push(){
                if (confirm("推送将会修改公众号菜单，确认修改吗？")) {
                    this.loading = true;
                    pushMenu().then((res) => {
                        //console.log(res);
                        this.loading = false;
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                            this.dialogFormVisible = false;
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }

</script>
<style>
    .p {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/wechat/wechatMenu.vue